<div class="control-display {{ class }}">
  <ngx-select
    [allowClear]="allowClear"
    [items]="userView"
    [placeholder]="label"
    (select)="userChange($event)"
    (remove)="userRemove()"
    [disabled]="disabled"
    showOptionNotFoundForEmptyItems="userView.length==0"
    [formControlName]="formControlName"
    autoSelectSingleOption="true"
    [defaultValue]="[formControl?.value]"
    [autoClearSearch]="true"
  >
    <ng-template #someContent ngx-select-option-selected let-option let-text="text">
      <div *ngIf="!multipleSelection">
        <span [innerHtml]="text"></span>
        <hr class="no-margin" />
      </div>
      <div *ngIf="multipleSelection">
        <span [innerHtml]="label"></span>
        <hr class="no-margin" />
      </div>    
    </ng-template>

    <ng-template
      ngx-select-option
      ngx-select-option-selected
      let-option
      let-text="text"
    >
      <span [innerHtml]="text"></span>
      <hr class="no-margin" />
    </ng-template>

    <ng-template ngx-select-option-not-found let-input>
      <div *ngIf="userView.length > 0">
        {{ 'NOT_FOUND' | translate }} "{{ input }}".
      </div>
      <div *ngIf="userView.length == 0">{{ 'EMPTY_LIST' | translate }}.</div>
    </ng-template>
  </ngx-select>
</div>
